import React from "react";
import { ShoppingBag, ArrowUpRight, Heart } from "lucide-react";
import { MERCH_URL } from "../lib/constants";
import { trackEvent } from "../lib/analytics";

export const Merch = () => {
    return (
        <section
            id="merch"
            data-testid="merch-section"
            className="relative py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-10">
                <a
                    href={MERCH_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackEvent("merch_clicked", { source: "merch_section" })}
                    data-testid="merch-cta-link"
                    className="group relative block overflow-hidden rounded-[40px] border border-lilac-200 bg-gradient-to-br from-lilac-900 via-[#3F2655] to-lilac-700 text-white p-10 md:p-14 shadow-[0_30px_70px_rgba(43,29,53,0.20)]"
                >
                    {/* gold accent */}
                    <div className="absolute -top-24 -right-20 w-96 h-96 rounded-full bg-gold/30 blur-3xl" aria-hidden />
                    <div className="absolute -bottom-32 -left-10 w-80 h-80 rounded-full bg-gold/15 blur-3xl" aria-hidden />

                    <div className="relative grid grid-cols-12 gap-8 items-center">
                        <div className="col-span-12 md:col-span-8">
                            <div className="eyebrow text-gold flex items-center gap-2 mb-5">
                                <ShoppingBag className="w-3.5 h-3.5" /> Hearts of Love · Inspirational Apparel
                            </div>
                            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight">
                                Wear the <em className="italic" style={{ color: "#E6C158" }}>becoming</em>.
                            </h2>
                            <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed max-w-xl">
                                Inspirational apparel, every-day reminders, and gold-stamped truth you can carry
                                with you. Visit the official Hearts of Love merch store on Bonfire.
                            </p>
                            <div className="mt-8 flex flex-wrap items-center gap-4">
                                <span className="inline-flex items-center gap-2 rounded-full bg-gold text-lilac-900 px-6 h-12 text-sm font-medium shadow-[0_10px_30px_rgba(212,175,55,0.45)] group-hover:bg-white transition-colors">
                                    Visit the Store
                                    <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                                </span>
                                <span className="text-xs text-white/60 inline-flex items-center gap-1.5">
                                    <Heart className="w-3.5 h-3.5" /> A portion of every sale supports the ministry
                                </span>
                            </div>
                        </div>
                        <div className="col-span-12 md:col-span-4 hidden md:block">
                            <div className="relative ml-auto w-full max-w-[260px] aspect-square rounded-[32px] border border-white/15 bg-white/5 backdrop-blur-sm p-6 flex flex-col justify-between">
                                <div className="text-[10px] uppercase tracking-[0.28em] text-gold/90">
                                    Bonfire · Official Store
                                </div>
                                <div>
                                    <div className="font-display text-3xl leading-tight">
                                        Hearts of <span className="italic" style={{ color: "#E6C158" }}>Love</span>
                                    </div>
                                    <div className="mt-2 text-xs text-white/70">
                                        Tees · Hoodies · Inspirational Apparel
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        </section>
    );
};
